export const MANAGERS_END_POINT = '/api/Managers/GetEntireHierarchy'
export const MANAGERS_LIST_END_POINT = '/api/Managers/GetManagers'
export const MANAGERS_CHILDREN_END_POINT = '/api/Managers/GetChildren'
export const MANAGERS_EXPORT_EXCEL = '/api/managers/ExportToExcel'
export const UPLOAD_MANAGERS_END_POINT = '/api/managers/uploadmanagers'
export const MANAGERS_ASSIGN_TAG = '/api/Managers/assigntag'
export const MANAGERS_REMOVE_TAG = '/api/Managers/removetag'
export const MANAGERS_ASSIGN_EMPLOYEE = '/api/ManagerEmployees/AssignEmployee'
export const MANAGERS_ASSIGN_EMPLOYEES = '/api/ManagerEmployees/AssignEmployees'
export const MANAGERS_REMOVE_EMPLOYEE = '/api/ManagerEmployees/RemoveEmployee'
export const MANAGERS_REMOVE_EMPLOYEES = '/api/ManagerEmployees/RemoveEmployees'
export const MANAGERS_MOVE_EMPLOYEE = '/api/ManagerEmployees/MoveEmployee'
export const MANAGERS_MOVE_EMPLOYEES = '/api/ManagerEmployees/MoveEmployees'
export const MANAGERS_UPDATE = '/api/Managers/update'
export const MANAGERS_ADD = '/api/Managers/add'
export const MANAGERS_DELETE = '/api/Managers/delete'
export const MANAGERS_MOVE = '/api/Managers/move'
export const MANAGERS_REMOVE_FROM_TAG = '/api/Managers/removemanagersfromtag'
export const MANAGERS_UPLOAD_APPEND = '/api/managers/uploadappend'



// WEBPACK FOOTER //
// ./src/api/managers/types.js